import { Component, Input, input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { Package } from 'src/app/micro-services/packages/models/package';
import { ESubscriptionType } from 'src/app/micro-services/subscription/enum/e-subscription-type';
import { Subscription } from 'src/app/micro-services/subscription/models/subscription';
import { SubscriptionFactoryService } from 'src/app/micro-services/subscription/services/subscription-factory.service';
import { SubscriptionPlateformService } from 'src/app/micro-services/subscription/services/subscription-plateform.service';
import { SubscriptionService } from 'src/app/micro-services/subscription/services/subscription.service';

@Component({
  selector: 'app-package-subscription-details',
  templateUrl: './package-subscription-details.component.html',
  styleUrls: ['./package-subscription-details.component.scss'],
})
export class PackageSubscriptionDetailsComponent  implements OnInit {

  @Input() package: Package;
  subscriptionService : SubscriptionService
  subscription$: Observable<Subscription> ;

constructor(
  private modalCtrl: ModalController,
  private readonly subscriptionFactoryService: SubscriptionFactoryService,
  private readonly alertController : AlertController
) { }

  async ngOnInit() {

    this.subscriptionService = this.subscriptionFactoryService.create(ESubscriptionType.Plateform);
    this.subscription$ = this.subscriptionService.GetLastSubscriptionByPackage(this.package.id);

  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

    async unsubscribe() {
    const alert = await this.alertController.create({
      header: 'Confirmation',
      message: 'Êtes-vous sûr de vouloir vous désabonner ?',
      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
          cssClass: 'secondary',
        },
        {
          text: 'Confirmer',
          handler: () => {
            this.modalCtrl.dismiss(null, "unsubscribe");
          }
        }
      ]
    });

    await alert.present();
  }



}
